import { render } from "./MuseumConfigurator.vue?vue&type=template&id=8ac4f20e&scoped=true"
import script from "./MuseumConfigurator.vue?vue&type=script&lang=js"
export * from "./MuseumConfigurator.vue?vue&type=script&lang=js"

import "./MuseumConfigurator.vue?vue&type=style&index=0&id=8ac4f20e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac4f20e"]])

export default __exports__